import { createContext } from 'react'

interface settingsContext {
  updateLocation: (_office_location: string, _initial_set?: boolean) => void
  cleanupSettings: () => void
  settings: string
}

export const SettingsContext = createContext<settingsContext>({
  updateLocation: (_office_location, _initial_set) => {
    console.log('SettingsContext -> updateLocation default behavior')
  },
  cleanupSettings: () => {
    console.log('SettingsContext -> cleanupSettings default behavior')
  },
  settings: '',
})
